import { ContactsDatatable } from "datatables/contacts"
export default class ContactsIndex extends ApplicationController {
  connect () {
    this.datatable = new ContactsDatatable()
  }
}